export const devMode = /\bdevconsole\b/.test(
  window.location.search + window.location.hash,
);
